import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Briefcase: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.15967 2.86714V1.4938C5.15967 0.947212 5.60688 0.5 6.15347 0.5H11.3213C11.8679 0.5 12.3151 0.947212 12.3151 1.4938V2.86714"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeMiterlimit="22.9256"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5541 7.30841V12.5747C15.5541 13.0835 15.1377 13.5 14.6289 13.5H2.84714C2.33834 13.5 1.92188 13.0836 1.92188 12.5747V7.33925"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeMiterlimit="22.9256"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50397 8.86578C4.24121 8.67921 1.30469 7.7462 1.30469 6.06675V3.87705C1.30469 3.36744 1.72032 2.95178 2.22995 2.95178H15.2454C15.755 2.95178 16.1706 3.36747 16.1706 3.87705V6.06675C16.1706 7.75672 13.197 8.69087 9.90967 8.8692"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeMiterlimit="22.9256"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.59668 7.94794H9.879V9.01199C9.879 9.59722 9.40018 10.0761 8.81495 10.0761H8.66074C8.07551 10.0761 7.59668 9.59722 7.59668 9.01199V7.94794Z"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeMiterlimit="22.9256"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

Briefcase.displayName = 'Briefcase'
